/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const EmailIcon = /*#__PURE__*/ createSvgIcon(
  'EmailIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.5 16a1.44 1.44 0 01-1.052-.448A1.44 1.44 0 012 14.5v-9c0-.403.15-.753.448-1.052A1.44 1.44 0 013.5 4h13c.413 0 .766.15 1.06.448.293.299.44.65.44 1.052v9c0 .403-.147.754-.44 1.052A1.433 1.433 0 0116.5 16h-13zm13-8.73l-6.104 3.5a.742.742 0 01-.396.126.532.532 0 01-.188-.031 1.45 1.45 0 01-.185-.088L3.5 7.271V14.5h13V7.27zM10 9.23l6.48-3.73H3.541L10 9.23zM3.5 7.001v.187-1.095.01V5.5v.603-.01 1.098-.187V14.5 7.002z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default EmailIcon;
